import React from 'react'

import { compose, withBeacon, withTranslation } from '@hocs'

import { isType, isSecretClas } from '@libs/postTools'
import { imageAssetUrl, feedbackUrl } from '@libs/appUrl'
import { trackingShareProperty } from '@app-core/beacon/beacon'

import PopSlidein from '@components/PopSlidein'
import SlideinItem from '@components/PopSlidein/SlideinItem'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import styles from './SharePop.scss'

class SharePop extends React.PureComponent {
  constructor(props) {
    super(props)
    const isSecret = isSecretClas(props.sharePost.get('clas')) || false
    const isPlace = isType(props.sharePost, 'place') || false
    const shareType = isSecret ? 'post.secret' : `${isPlace ? 'place' : 'post'}`
    this.state = {
      isPlace,
      shareType,
    }
  }

  sharePostTrack = (via = '') => {
    const { shareType } = this.state
    const extProperties = {}
    if (via) extProperties['share-via'] = via
    const properties = trackingShareProperty(this.props.sharePost, extProperties)
    this.props.amplitudeEventTrack(`share.${shareType}`, properties)
  }

  _onCopy = () => {
    this.sharePostTrack('link')
    window.alert(this.props.t('common:已複製至剪貼簿'))
  }

  _shareFB = () => {
    this.sharePostTrack('facebook')
    window.open(`https://www.facebook.com/share.php?u=${encodeURIComponent(this.props.url)}`)
  }

  _shareMessenger = () => {
    this.sharePostTrack('messenger')
    window.open(
      `https://www.addthis.com/bookmark.php?v=300&winname=addthis&pub=ra-5a606bcb2740770f&source=smlsh-1.0&lng=zh&s=messenger&wid=y0dp&url=${encodeURIComponent(
        this.props.url,
      )}`,
    )
  }

  _shareLINE = () => {
    const { title = '', url } = this.props
    this.sharePostTrack('line')
    window.open(`https://lineit.line.me/share/ui?url=${url}&amp;text=${title}`)
  }

  _feedback = () => {
    const { url, userId, sharePost, amplitudeEventTrack } = this.props
    amplitudeEventTrack('report.wrong.info', trackingShareProperty(sharePost))
    window.open(feedbackUrl({ url, userId }))
  }

  _report = () => {
    const { isPlace, shareType } = this.state
    const { sharePost, onClickReport, openConfirmDialog, t, amplitudeEventTrack } = this.props
    openConfirmDialog({
      title: isPlace ? t('common:是否檢舉此地點?') : t('common:是否檢舉此文章?'),
      onSure: () => {
        amplitudeEventTrack(`report.${shareType}`, trackingShareProperty(sharePost))
        onClickReport()
      },
    })
  }

  render() {
    const { isOpen, url, t, onClose } = this.props

    return (
      <PopSlidein isOpen={isOpen} close={onClose}>
        <div className="popSlidein__wrapper popSlidein__wrapper--info">
          <style jsx>{styles}</style>
          <div className="popSlidein__content popSlidein__content--info">
            <div className="popSlidein__actionIcons">
              <SlideinItem
                img={imageAssetUrl('icon/icon-footerNav-facebook@3x.png')}
                onClick={this._shareFB}
                text={t('Facebook')}
              />
              <SlideinItem
                img={imageAssetUrl('icon/icon-footerNav-messenger@3x.png')}
                onClick={this._shareMessenger}
                text={t('Messenger')}
              />
              <SlideinItem
                img={imageAssetUrl('icon/icon-footerNav-line@3x.png')}
                onClick={this._shareLINE}
                text={t('LINE')}
              />
            </div>
          </div>
          <div className="popSlidein__content popSlidein__content--info">
            <div className="popSlidein__actionIcons">
              <CopyToClipboard text={url} onCopy={this._onCopy}>
                <SlideinItem
                  img={imageAssetUrl('icon/share-link@3x.png')}
                  text={t('common:複製連結')}
                />
              </CopyToClipboard>
              <SlideinItem
                img={imageAssetUrl('icon/share-alert@3x.png')}
                onClick={this._report}
                text={t('common:檢舉')}
              />
              <SlideinItem
                img={imageAssetUrl('icon/share-report@3x.png')}
                onClick={this._feedback}
                text={t('common:錯誤回報')}
              />
            </div>
          </div>
          <div className="btn cancel" onClick={onClose} data-btn-text={t('關閉')} />
        </div>
      </PopSlidein>
    )
  }
}

export default compose(withBeacon, withTranslation())(SharePop)
